


























































































































































import Vue from 'vue'
import dayjs from 'dayjs'
import Button from '@/components/globals/Button.vue'
import AreaByPrefectureModal from '@/components/modal/AreaModal/AreaByPrefectureModal.vue'
import DateModal from '@/components/modal/DatetimeModal/DateModal.vue'
import TimeModal, {
  TimeRange,
  // Time,
} from '@/components/modal/DatetimeModal/TimeModal.vue'
import PriceModal, {
  PriceRange,
} from '@/components/modal/PriceModal/PriceModal.vue'
import ActivityModal from '@/components/modal/ActivityModal/ActivityModal.vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'
import OptionList from './OptionList.vue'
import FacilityNameSearchInput from '../FacilityNameSearchInput.vue'
import SelectInputButton from '../SelectInputButton.vue'
import { Activity, ActivityId } from '@/core/Activities'
import {
  Area,
  AreaId,
  AreasByPref,
  SexLimitationOptions,
  sexLimitationOptions,
  ExerciseLevelOptions,
  exerciseLevelOptions,
  OtherConditionOptions,
  otherConditionOptions,
  EXCLUDE_FULL_RESERVATIONS_KEY,
  SearchParams,
  initialSearchParams,
  facilitiesSearchCount,
  useFacilitiesMetadataStore,
} from '@/core/Facilities'
import { Gender, ProgramLevel } from '@/core/Programs'
import snackbar from '@/tools/snackbar'
import isEqual from 'lodash.isequal'

const facilitiesMetadataStore = useFacilitiesMetadataStore()

export default Vue.extend({
  name: 'SearchFacilityDetailForm',
  components: {
    Button,
    FacilityNameSearchInput,
    SelectInputButton,
    AreaByPrefectureModal,
    DateModal,
    TimeModal,
    ActivityModal,
    PriceModal,
    OptionList,
    Loading,
  },
  filters: {
    toFormattedDates: (dates: string[]) => {
      return dates.length === 0
        ? ''
        : dates.map((date) => dayjs(date).format('M月D日')).join(', ')
    },
    toFormattedTimeRange: ({ from, to }: TimeRange) => {
      if (!from.hour && !from.minute && !to.hour && !to.minute) return ''
      return `${from.hour ? `${from.hour}:${from.minute}` : ''}〜${
        to.hour ? `${to.hour}:${to.minute}` : ''
      }`
    },
  },
  props: {
    id: {
      type: String as () => string,
      default: 'SearchFacilityDetailForm',
    },
    values: {
      type: Object as () => SearchParams,
      default: () => ({ ...initialSearchParams }),
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingResultCount: false,
      resultCount: 0,
      innerValues: {
        ...this.values,
        activityIds: [...(this.values.activityIds || [])],
        areaIds: [...(this.values.areaIds || [])],
        sexLimitations: [...(this.values.sexLimitations || [])],
        exerciseLevels: [...(this.values.exerciseLevels || [])],
        dates: [...(this.values.dates || [])],
      } as SearchParams,
    }
  },
  computed: {
    activities(): Activity[] {
      return facilitiesMetadataStore.getActivities()
    },
    areasByPref(): AreasByPref[] {
      return facilitiesMetadataStore.getAreasByPref()
    },
    areas(): Area[] {
      return facilitiesMetadataStore.getAreas()
    },
    areaValue(): string {
      if (this.areas.length === 0) return ''

      if (this.innerValues.areaIds.length <= 2) {
        return this.innerValues.areaIds
          .map((id) => this.areas.find((a) => a.id === id)?.name || '')
          .join(', ')
      }

      const [first, second, ...rest] = this.innerValues.areaIds

      const firstArea = this.areas.find((a) => a.id === first)?.name
      const secondArea = this.areas.find((a) => a.id === second)?.name

      return `${firstArea}, ${secondArea}, 他${rest.length}件選択中`
    },
    activityValue(): string {
      if (this.activities.length === 0) return ''

      if (this.innerValues.activityIds.length <= 2) {
        return this.innerValues.activityIds
          .map((id) => this.activities.find((a) => a.id === id)?.name || '')
          .join(', ')
      }

      const [first, second, ...rest] = this.innerValues.activityIds

      const firstActivity = this.activities.find((a) => a.id === first)?.name
      const secondActivity = this.activities.find((a) => a.id === second)?.name

      return `${firstActivity}, ${secondActivity}, 他${rest.length}件選択中`
    },
    priceValue(): string {
      if (
        this.innerValues.priceFrom === null &&
        this.innerValues.priceTo === null
      ) {
        return ''
      }
      return `${
        this.innerValues.priceFrom === null
          ? '指定なし'
          : `${this.innerValues.priceFrom}pt`
      }〜${
        this.innerValues.priceTo === null
          ? '指定なし'
          : `${this.innerValues.priceTo}pt`
      }`
    },
    timeRangeValue(): TimeRange {
      const [fromHour, fromMinute] = this.innerValues.startTimeFrom
        ? this.innerValues.startTimeFrom.split(':')
        : ['', '']
      const [toHour, toMinute] = this.innerValues.startTimeTo
        ? this.innerValues.startTimeTo.split(':')
        : ['', '']

      return {
        from: { hour: fromHour, minute: fromMinute },
        to: { hour: toHour, minute: toMinute },
      }
    },
    priceRangeValue(): PriceRange {
      return {
        from: this.innerValues.priceFrom,
        to: this.innerValues.priceTo,
      }
    },
    sexLimitationOptions(): SexLimitationOptions {
      return sexLimitationOptions
    },
    exerciseLevelOptions(): ExerciseLevelOptions {
      return exerciseLevelOptions
    },
    otherConditionOptions(): OtherConditionOptions {
      return otherConditionOptions
    },
    otherConditionValues(): string[] {
      return this.innerValues.excludeFullReservations
        ? [EXCLUDE_FULL_RESERVATIONS_KEY]
        : []
    },
    rawValues(): SearchParams {
      return {
        ...this.innerValues,
        activityIds: [...(this.innerValues.activityIds || [])],
        areaIds: [...(this.innerValues.areaIds || [])],
        sexLimitations: [...(this.innerValues.sexLimitations || [])],
        exerciseLevels: [...(this.innerValues.exerciseLevels || [])],
        dates: [...(this.innerValues.dates || [])],
      }
    },
    isChanged(): boolean {
      return !isEqual(initialSearchParams, this.innerValues)
    },
    isChangedFromCurrent(): boolean {
      return isEqual(initialSearchParams, this.innerValues)
        ? true
        : !isEqual(this.values, this.innerValues)
    },
  },
  watch: {
    rawValues() {
      this.fetchCount()
    },
  },
  async created() {
    this.isLoading = true

    const isInitialFetch = true
    await Promise.all([this.fetchCount(isInitialFetch), this.fetchData()])

    this.isLoading = false
  },
  methods: {
    async fetchData() {
      await facilitiesMetadataStore.fetch()
    },
    async fetchCount(initialFetch = false) {
      this.isLoadingResultCount = true

      if (initialFetch) {
        const { count } = await facilitiesSearchCount(this.rawValues)
        this.resultCount = count
      } else {
        // UIから市区町村コードを変更できないため、検索条件が変更されたら外す
        const { cityCode: _, ...rest } = this.rawValues
        const { count } = await facilitiesSearchCount({
          cityCode: null,
          ...rest,
        })
        this.resultCount = count
      }

      this.isLoadingResultCount = false
    },
    setFacilityName(name: string | null) {
      this.$set(this.innerValues, 'facilityName', name || null)
    },
    setAreas(areaIds: AreaId[]) {
      this.$set(this.innerValues, 'areaIds', areaIds)
    },
    setDates(dates: string[]) {
      this.$set(this.innerValues, 'dates', dates)
    },
    setTimeRange({ from, to }: TimeRange) {
      this.$set(
        this.innerValues,
        'startTimeFrom',
        from.hour && from.minute ? `${from.hour}:${from.minute}` : null
      )
      this.$set(
        this.innerValues,
        'startTimeTo',
        to.hour && to.minute ? `${to.hour}:${to.minute}` : null
      )
    },
    setPriceRange({ from, to }: PriceRange) {
      this.$set(this.innerValues, 'priceFrom', from)
      this.$set(this.innerValues, 'priceTo', to)
    },
    setActivities(activityIds: ActivityId[]) {
      this.$set(this.innerValues, 'activityIds', activityIds)
    },
    setSexLimitations(sexLimitations: Gender[]) {
      this.$set(this.innerValues, 'sexLimitations', sexLimitations)
    },
    setExerciseLevels(exerciseLevels: ProgramLevel[]) {
      this.$set(this.innerValues, 'exerciseLevels', exerciseLevels)
    },
    setOtherConditions(innerValues: string[]) {
      this.innerValues.excludeFullReservations = innerValues.includes(
        EXCLUDE_FULL_RESERVATIONS_KEY
      )
    },
    onClearFacilityName() {
      this.setFacilityName(null)
    },
    onClearAreas() {
      this.setAreas([])
    },
    onClearActivities() {
      this.setActivities([])
    },
    onClearDates() {
      this.setDates([])
      // 日付をクリアしたら時間もクリアしておく
      this.onClearTime()
    },
    onClearTime() {
      this.setTimeRange({
        from: { hour: '', minute: '' },
        to: { hour: '', minute: '' },
      })
    },
    onClearPrice() {
      this.setPriceRange({
        from: null,
        to: null,
      })
    },
    onClearAll() {
      this.innerValues = { ...initialSearchParams }
      snackbar({ text: '検索条件を消去しました' })
    },
    onSubmit() {
      this.$emit('submit', this.rawValues)
    },
  },
})
